import { useState } from 'react';
import { Tab, TabGroup } from '@components/Tab';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const TabsSection = () => {
  const [activeTab, setActiveTab] = useState('tab1');

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Tabs"
        description="Tab navigation for switching between content sections."
        figmaNodeId="6-242"
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Tab Group</h3>
        <TabGroup>
          <Tab label="Overview" active={activeTab === 'tab1'} onClick={() => setActiveTab('tab1')} />
          <Tab label="Generate Leads" active={activeTab === 'tab2'} onClick={() => setActiveTab('tab2')} />
          <Tab label="Manage Leads" active={activeTab === 'tab3'} onClick={() => setActiveTab('tab3')} />
        </TabGroup>
        <div className={styles.tabContent}>
          {activeTab === 'tab1' && <p>Overview content...</p>}
          {activeTab === 'tab2' && <p>Generate Leads content...</p>}
          {activeTab === 'tab3' && <p>Manage Leads content...</p>}
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Individual Tab States</h3>
        <div className={styles.row}>
          <Tab label="Active" active />
          <Tab label="Inactive" active={false} />
          <Tab label="Disabled" disabled />
        </div>
      </div>
    </section>
  );
};
